module.exports = __webpack_public_path__ + "img/sortup.2836e63b.svg";